import { useSelector } from 'react-redux';
import { shouldRender } from '../../utils';

/**
 * Component that renders the children components based on the access control condition.
 * @param {Object} props - The component props.
 * @param {boolean} props.accessControl - The access control condition.
 * @param {ReactNode} props.children - The child components to render.
 * @returns {ReactNode|null} - The rendered child components or null.
 */
export const AccessControl = (props) => {
  const { ac, children } = props;
  return accessControl(ac) ? children : null;
};

/**
 * Function that wraps shouldRender and connects to providers.
 * @param {Array} accessControl - The access control conditions.
 * @returns {boolean} - Returns true if the component should be rendered, otherwise false.
 */
export const accessControl = (accessControl) => {
  const configuration = useSelector((state) => state.config?.settings?.core);
  return shouldRender({ accessControl, configuration });
};
